import { DownloadIcon, DocumentWithCutIcon, MicrosoftWordIcon } from '@ui/kit';
import { ModalButton } from '../atom.modal-button.js';
import { modal, heading, content } from '../shared.modals.style.js';
import { useExport } from './hook.export.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const makeExportModalConfig = options => ({
  theme: "dialog",
  className: modal,
  content: /*#__PURE__*/jsx(Modal, {
    ...options
  })
});
function Modal(props) {
  const pdfExport = useExport(props.input, {
    format: "pdf",
    orientation: props.printOrientation ?? "portrait",
    css: props.printCss,
    componentTitle: props.componentTitle,
    onBeforeExport: props.onBeforeExport,
    onAfterExport: props.onAfterExport
  });
  const wordExport = useExport(props.input, {
    format: "docx",
    orientation: props.printOrientation ?? "portrait",
    css: props.printCss,
    componentTitle: props.componentTitle,
    onBeforeExport: props.onBeforeExport,
    onAfterExport: props.onAfterExport
  });
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("h1", {
      className: heading,
      children: [/*#__PURE__*/jsx(DownloadIcon, {
        height: "20"
      }), " ", /*#__PURE__*/jsx("span", {
        children: "Download"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: content,
      children: [/*#__PURE__*/jsxs(ModalButton, {
        onClick: pdfExport.export,
        async: typeof pdfExport.progress !== "undefined" ? {
          type: "download",
          progress: pdfExport.progress
        } : undefined,
        state: !pdfExport.progress && pdfExport.hasExported ? "success" : undefined,
        children: [/*#__PURE__*/jsx(ModalButton.Icon, {
          children: /*#__PURE__*/jsx(DocumentWithCutIcon, {
            height: "26"
          })
        }), /*#__PURE__*/jsx(ModalButton.Label, {
          children: "PDF"
        })]
      }), /*#__PURE__*/jsxs(ModalButton, {
        onClick: wordExport.export,
        async: typeof wordExport.progress !== "undefined" ? {
          type: "download",
          progress: wordExport.progress
        } : undefined,
        state: !wordExport.progress && wordExport.hasExported ? "success" : undefined,
        children: [/*#__PURE__*/jsx(ModalButton.Icon, {
          children: /*#__PURE__*/jsx(MicrosoftWordIcon, {
            height: "26"
          })
        }), /*#__PURE__*/jsx(ModalButton.Label, {
          children: "Word"
        })]
      })]
    })]
  });
}

export { makeExportModalConfig };
//# sourceMappingURL=modal.js.map
